import React from 'react';
import { get } from 'lodash';
import { combineClassNames } from 'core/css';
import { TranslateContext } from 'core/translate';
import Radio from 'core/controls/radio/Radio';
import Raw from '../../../../common/Raw';
import PriceWithDisclaimer from '../../priceWithDisclaimer/PriceWithDisclaimer';
import {
  BYO_CLOSE,
  dispatchCustomEvent,
} from '../../../../utils/customMessage';

const EngineTransmissionOption = (props) => {
  const {
    option,
    checked,
    disclaimer,
    hideRadioButtonCircle,
    index,
    analyticsKey,
    onChange,
  } = props;

  const {
    engineDescription,
    transmissionDescription,
    msrp,
    message,
    trimName,
  } = option;

  const displayMsrpValue = get(msrp, 'amount.value', msrp);

  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    dispatchCustomEvent(BYO_CLOSE);

    if (!checked) {
      onChange(option);
    }
  };

  return (
    <div
      className={combineClassNames([
        'engine-transmission-container',
        'stat-radio',
        checked ? 'option__control--checked' : '',
      ])}
      data-dtm={`${analyticsKey} ${option.driveType}`}
      onClick={onClick}>
      <Radio
        id={`engine-option__${index}--${trimName}`}
        className={combineClassNames([
          'control--top option__control engine-transmission-option',
        ])}
        checked={checked}
        hideRadioButtonCircle={hideRadioButtonCircle}
        analyticsKey={`${analyticsKey} ${option.driveType}`}>
        <div style={{ flex: 1 }}>
          <div className="engine-transmission-option__transmission">
            <Raw as="div" value={engineDescription} />
            {engineDescription !== transmissionDescription && (
              <Raw as="div" value={transmissionDescription} />
            )}
          </div>
          {(displayMsrpValue || message) && (
            <TranslateContext.Consumer>
              {(translate) => (
                <div className="option__disclaimer">
                  <PriceWithDisclaimer
                    value={displayMsrpValue}
                    message={message}
                    disclaimer={disclaimer}
                    analyticsKey={translate('component.common.select.engine')}
                    analyticsKey2={engineDescription}
                    useModal
                  />
                </div>
              )}
            </TranslateContext.Consumer>
          )}
        </div>
      </Radio>
    </div>
  );
};

export default EngineTransmissionOption;
